export function getCookie(name) {
    var value = '; ' + document.cookie;
    var parts = value.split('; ' + name + '=');
    if (parts.length == 2)
        return parts.pop().split(';').shift();
}
export function saveCookie(name, value, expires) {
    document.cookie = "".concat(name, "=").concat(value, "; expires=").concat(expires.toUTCString(), "; path=/; SameSite=Strict; Secure");
}
